import Api from "./Api";

export default {
  baseURL() {
    return Api.defaults.baseURL.replace(/\/api.?$/, "");
  },
  async paginate(data) {
    return Api.post("/productos/paginate", data);
  },
  /// CRUD
  async ver(id) {
    return Api.get("/productos/ver/" + id);
  },
  async publicar(data) {
    return Api.post("/productos/publicar/", data);
  }
};
